module.exports = __webpack_public_path__ + "img/upsort1.f8bf1c6a.png";